import React from 'react';

import { usePositionsGetQueryById } from '../../Common/Queries/positionsQueries';

export function CustomFieldContainer(props) {
  const { children, positionID, ...rest } = props;
  const child = React.Children.only(children);
  const positionData = usePositionsGetQueryById({ reqId: positionID });

  return React.cloneElement(child, { ...rest, positionID, positionData });
}
